/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_ResendInputs */

const en_us2_coach_resend = /** @type {(inputs: Coach_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask again`)
};

const pt_br2_coach_resend = /** @type {(inputs: Coach_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar de novo`)
};

const es_419_coach_resend = /** @type {(inputs: Coach_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntar de nuevo`)
};

const pt_pt2_coach_resend = /** @type {(inputs: Coach_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar de novo`)
};

const fr_fr2_coach_resend = /** @type {(inputs: Coach_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redemander`)
};

const de_de2_coach_resend = /** @type {(inputs: Coach_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch mal fragen`)
};

const it_it2_coach_resend = /** @type {(inputs: Coach_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi di nuovo`)
};

/**
* | output |
* | --- |
* | "Ask again" |
*
* @param {Coach_ResendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_resend = /** @type {((inputs?: Coach_ResendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_ResendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_resend(inputs)
	if (locale === "es-419") return es_419_coach_resend(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_resend(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_resend(inputs)
	if (locale === "de-DE") return de_de2_coach_resend(inputs)
	if (locale === "it-IT") return it_it2_coach_resend(inputs)
	return en_us2_coach_resend(inputs)
});
export { coach_resend as "coach.resend" }